import React, { memo } from "react";
import { getOperatingSystem } from "../../utils";
import { MdClose } from "react-icons/md";
import { GoX, GoDash } from "react-icons/go";
function AppHeader(props) {
  var _window, _window$navigator;
  var os = getOperatingSystem(window);
  var isWindows = os === "windows";
  var localAppVersion = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.appVersion.split("Workfolio/").pop().split(" ")[0];
  return /*#__PURE__*/React.createElement("div", {
    className: "desktop-app-header"
    // onDoubleClick={props.handleFullScreen}
  }, !isWindows ? /*#__PURE__*/React.createElement("div", {
    className: "mac-traffic-lights"
  }, /*#__PURE__*/React.createElement("div", {
    className: "light",
    id: "close",
    onClick: props.handleClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "light",
    id: "min",
    onClick: props.handleMinimize
  })) : /*#__PURE__*/React.createElement("div", {
    className: "draggable"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "draggable",
    style: {
      flex: 1,
      margin: 0,
      marginLeft: isWindows ? 40 : 0
    }
  }, "Workfolio ", localAppVersion), isWindows ? /*#__PURE__*/React.createElement("div", {
    className: "traffic-lights"
  }, /*#__PURE__*/React.createElement("div", {
    className: "light",
    id: "min",
    onClick: props.handleMinimize
  }, /*#__PURE__*/React.createElement(GoDash, null)), /*#__PURE__*/React.createElement("div", {
    className: "light",
    id: "close",
    onClick: props.handleClose
  }, /*#__PURE__*/React.createElement(GoX, null))) : /*#__PURE__*/React.createElement("div", {
    className: "draggable"
  }));
}
export default /*#__PURE__*/memo(AppHeader);